import styled from 'styled-components';

export const CopyrightWrapper = styled.div`
`;
